import React, { useRef } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import Scrollbars from 'react-custom-scrollbars'
import { useTranslation } from 'react-i18next'
import Notification, {
  DeleteAllButton,
  Loader,
  NotificationLabel,
} from '../../components/Notifications'
import TemplateSendModal from '../BookingCalendar/ReservationModal/TemplateSendModal'

const Notifications = function({
  hasMore,
  deleteNotification,
  notifications,
  loadNotifications,
  onScroll = null,
  size = 1,
  notRead,
  height = undefined,
  minHeight = undefined,
  withoutHeader = false,
  isLoading,
}) {
  const scrollRef: React.RefObject<any> = useRef()
  const { t } = useTranslation()

  function getScrollParent() {
    return scrollRef.current ? scrollRef.current.view : null
  }

  function Null() {
    return <div style={{ display: 'null' }}></div>
  }

  return (
    <>
      {!withoutHeader && <NotificationLabel size={size} count={notRead} />}
      <Scrollbars
        ref={scrollRef}
        onScroll={onScroll}
        autoHeight={true}
        autoHeightMax={`calc(${height ? height : '100vh'} - ${50 * size}px)`}
        autoHeightMin={minHeight ? minHeight : 0}
        renderThumbHorizontal={Null}
        renderTrackHorizontal={Null}
      >
        <InfiniteScroll
          pageStart={0}
          useWindow={false}
          loadMore={loadNotifications}
          hasMore={!isLoading && hasMore}
          threshold={100}
          getScrollParent={getScrollParent}
          loader={<Loader />}
        >
          {notifications.map(not => (
            <Notification
              size={size}
              key={`notification-${not.id}`}
              deleteNotification={deleteNotification(not.id)}
              notification={not}
            />
          ))}
          {!hasMore && (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                fontSize: `${16 * size}px`,
                justifyContent: 'center',
                margin: `${10 * size}px 0px`,
              }}
            >
              {t('BBO_930_thats_all')}
            </div>
          )}
        </InfiniteScroll>
      </Scrollbars>
      <DeleteAllButton
        size={size}
        notRead={notRead}
        deleteAll={deleteNotification('all')}
      />
      <TemplateSendModal />
    </>
  )
}

export default Notifications
